export default __webpack_public_path__ + "static/media/ic_arrow_left.0b1442e1.svg";